export const REQUEST_FETCH_ENTITIES_AD = "REQUEST_FETCH_ENTITIES_EM";
export const FETCH_ENTITIES_AD_SUCCESS = "FETCH_ENTITIES_EM_SUCCESS";
export const FETCH_ENTITIES_AD_FAILURE = "FETCH_ENTITIES_EM_FAILURE";

export const CLEAR_FETCH_ENTITIES_AD_STATES = "CLEAR_FETCH_ENTITIES_EM_STATES";
